import { useEffect, useState } from 'react'
import { API_INTERNAL_MOVEMENT } from 'services/apiInternalMovement'
import { useFetch } from 'services/useFetch'
import Filter from '../../../components/commons/filter'
import { deepClone } from '../../../utils/utils'

const FILTER = {
    DEPARTMENT: 'departments',
    DIVISION: 'divisions',
    GRADE: 'grades',
    CHANGE_TYPE: 'change_types',
}

const QUERY_PARAMS = {
    [FILTER.DEPARTMENT]: 'department_ids',
    [FILTER.DIVISION]: 'division_ids',
    [FILTER.GRADE]: 'grade_ids',
    [FILTER.CHANGE_TYPE]: 'change_types',
}

const INITIAL_DATA_FILTER = [
    { label: 'Department', value: FILTER.DEPARTMENT },
    { label: 'Divisi', value: FILTER.DIVISION },
    { label: 'Grade', value: FILTER.GRADE },
    { label: 'Tipe Perubahan', value: FILTER.CHANGE_TYPE },
]

const INITIAL_FILTER = {
    department_ids: [],
    division_ids: [],
    grade_ids: [],
    change_types: [],
}

export const InternalMovementFilterContainer = ({ onSubmit, queryFilter }) => {
    const [show, setShow] = useState(false)
    const [activeFilter, setActiveFilter] = useState(INITIAL_DATA_FILTER[0])
    const [filter, setFilter] = useState(INITIAL_FILTER)
    const [filterCount, setFilterCount] = useState()
    const [errorFilter, setErrorFilter] = useState({})
    const [options, setOptions] = useState()

    const { fetching: getDepartmentList } = useFetch(API_INTERNAL_MOVEMENT.LIST_DEPARTMENT, {}, { isFetching: true })
    const { fetching: getDivisionList } = useFetch(API_INTERNAL_MOVEMENT.LIST_DIVISION, {}, { isFetching: true })
    const { fetching: getGradeList } = useFetch(API_INTERNAL_MOVEMENT.LIST_GRADE, {}, { isFetching: true })
    const { fetching: getChangeTypeList } = useFetch(API_INTERNAL_MOVEMENT.LIST_CHANGE_TYPE, {}, { isFetching: true })

    useEffect(() => {
        ;(async () => {
            const [departmentList, divisionList, gradeList, changeTypeList] = await Promise.all([
                getDepartmentList(),
                getDivisionList(),
                getGradeList(),
                getChangeTypeList(),
            ])

            setOptions({
                [FILTER.DEPARTMENT]: departmentList?.data,
                [FILTER.DIVISION]: divisionList?.data,
                [FILTER.GRADE]: gradeList?.data,
                [FILTER.CHANGE_TYPE]: changeTypeList?.data,
            })
        })()
    }, [])

    useEffect(() => {
        if (queryFilter) {
            const newQueryFilter = deepClone(queryFilter)
            setFilter(newQueryFilter)
            countFilterLength(newQueryFilter)
        }
    }, [queryFilter])

    const onCloseHandler = () => {
        setShow(false)
        setErrorFilter({})
    }

    const onSelectFilter = (item) => {
        setActiveFilter(item)
    }

    const onChangeOption = (item) => {
        const { name, value, checked } = item
        const arrChecked = filter?.[QUERY_PARAMS[name]] || []

        if (checked) {
            arrChecked.push(String(value))
        } else {
            const indexRemove = arrChecked.indexOf(String(value))
            arrChecked.splice(indexRemove, 1)
        }
        setFilter({ ...filter, [QUERY_PARAMS[name]]: arrChecked })
    }

    const validateFilter = (query) => {
        return new Promise((resolve, reject) => {
            const errors = {}
            setErrorFilter(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmitFilter = () => {
        const queryFilter = { ...filter }
        validateFilter(queryFilter).then(() => {
            Object.entries(queryFilter).forEach(([key, item]) => {
                if (Array.isArray(queryFilter[key])) queryFilter[key] = item.join(',')
            })
            onSubmit(queryFilter)
            onCloseHandler()
        })
    }

    const countFilterLength = (filter) => {
        let totalLength = 0
        for (const key in filter) {
            if (filter.hasOwnProperty(key)) {
                if (Array.isArray(filter[key])) {
                    totalLength += filter[key].length
                } else {
                    totalLength += 1
                }
            }
        }
        setFilterCount(totalLength)
    }

    const onClearFilter = () => {
        setFilter(deepClone(INITIAL_FILTER))
        setErrorFilter({})
    }

    const props = {
        show: show,
        onShow: () => setShow(true),
        onClose: onCloseHandler,
        queryParams: QUERY_PARAMS,
        filterList: INITIAL_DATA_FILTER,
        activeFilter,
        onSelectFilter,
        filter,
        filterCount,
        options,
        onChangeOption,
        onSubmitFilter,
        onClearFilter,
        errorFilter,
    }

    return <Filter {...props} />
}
